
import { BackButton } from "@/components/ui/back-button";
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <section>
      <BackButton />
      
      <h1 className="text-[72px] font-medium mb-4">Speaking Engagements</h1>
      <p className="text-[22px] font-inter mb-12">
        Transform your next event with insights on building human-centered products and communities in the AI era. With a decade of experience scaling digital products and nurturing communities, I deliver actionable frameworks and engaging stories that resonate with product leaders, founders, and teams.
      </p>
    </section>
  );
};
